import { GlobalNavSubMenuCaseStudyStoryblok } from '@/lib/types/component-types-sb'
import { cn } from '@/lib/utils'
import { ComponentProps } from 'react'
import { StoryblokImage } from '../storyblok-image'
import { StoryblokLink } from '../storyblok-link'

export function NavSubMenuCaseStudy({
  col,
  className,
  ...props
}: { col: GlobalNavSubMenuCaseStudyStoryblok } & ComponentProps<typeof StoryblokLink>) {
  // If no case study is provided, return null
  if (!col.caseStudy || typeof col.caseStudy === 'string') {
    return null
  }

  const article = col.caseStudy.content

  return (
    <StoryblokLink
      link={{
        linktype: 'story',
        cached_url: col.caseStudy.full_slug,
      }}
      className={cn('px-3', className)}
      {...props}
    >
      <div className="bg-accent relative mb-3 h-44 w-full overflow-hidden rounded-md lg:h-36">
        {article.featuredImage?.filename && (
          <StoryblokImage
            image={article.featuredImage}
            cropWidth={400}
            cropHeight={300}
            className="absolute bottom-0 left-0 h-full w-full object-cover object-center"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        <span className="absolute bottom-2.5 left-2.5 line-clamp-2 text-sm font-medium text-white">
          {article.title}
        </span>
      </div>
      <p className="text-muted-foreground line-clamp-3 text-xs">{article.excerpt}</p>
    </StoryblokLink>
  )
}
